import React from "react";
import { ButtonDefault } from "@/components/Button/Button";
import LoaderSpinner from "@/components/Loader/LoaderSpinner";
import WarningIcon from "@/components/icons/WarningIcon";
import ImagePreview from "../ImagePreview/ImagePreview";
import iconCamera from "@/assets/icons/iconCamera.svg";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";
import s from "./WidgetUploadStep.module.css";

const WidgetUploadStep = ({
  isMobile,
  imageFile,
  previewUrl,
  error,
  isLoading,
  onTakePhoto,
  onUploadFromGallery,
  onImageClick,
  onStartTryOn,
  selectedCloth,
  isProcessing,
}) => {
  return (
    <>
      {isMobile && (
        <div className={`${containerStyles.actions} ${s.actions}`}>
          <ButtonDefault
            className={containerStyles.buttonStart}
            onClick={onTakePhoto}
            disabled={isLoading || isProcessing}
          >
            СДЕЛАТЬ ФОТО
          </ButtonDefault>
          <ButtonDefault
            variant="light"
            className={containerStyles.buttonStart}
            onClick={onUploadFromGallery}
            disabled={isLoading || isProcessing}
          >
            ЗАГРУЗИТЬ ИЗ ГАЛЕРЕИ
          </ButtonDefault>
        </div>
      )}

      {!imageFile && (
        <div
          className={containerStyles.content}
          onClick={!isMobile ? onUploadFromGallery : undefined}
        >
          {isLoading || isProcessing ? (
            <LoaderSpinner />
          ) : (
            <div
              className={`${containerStyles.contentInfo} ${
                error ? containerStyles.error : ""
              }`}
            >
              {error ? (
                <>
                  <WarningIcon width={34} height={30} />
                  <p>{error}</p>
                </>
              ) : (
                <>
                  <img src={iconCamera} alt="camera" />
                  <p>
                    Загрузите ваше фото в полный рост для виртуальной примерки
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {imageFile && (
        <ImagePreview
          previewUrl={previewUrl}
          onClick={onImageClick}
          isMobile={isMobile}
        />
      )}

      {imageFile && (
        <div className={`${containerStyles.actions} ${s.actions}`}>
          <ButtonDefault
            className={containerStyles.buttonStart}
            onClick={onStartTryOn}
            disabled={isProcessing}
          >
            {isMobile ? "НАЧАТЬ ПРИМЕРКУ" : "Начать примерку"}
          </ButtonDefault>
        </div>
      )}
    </>
  );
};

export default WidgetUploadStep;
